<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, defineProps, defineEmits, defineExpose, onMounted, computed } from 'vue'
import { useGetImg } from './useGetImg'
import { getRandom } from '@/util/util'
import { filePreview } from "@/api/global.js";
import { aiextractfilemetadata } from '@/port/common/homeworkCorrection.js'
import toolModel from './toolModel.vue'
import { MY_CONSTANTS } from '@/util/constants';

const props = defineProps({
  uploadList: {
    type: Array,
    default: () => [],
  },
  uploadInfo: {
    type: Object,
    default: () => ({})
  }
})

const { getImg } = useGetImg()

const emit = defineEmits(['back', 'confirm'])

const isCheckAll = ref(true)
const isIndeterminate = ref(false)
const showPreview = ref(false)
const srcList = ref([])
const imgList = ref([])
const resImgList = ref([])

onMounted(() => {
  // getListInfo()
})

const openfile = (item) => {
  if (item.type === 'document') {
    filePreview(item, false)
  } else if (item.type === 'image') {
    showPreview.value = true
    srcList.value = [item.previewUrl]
  }
}

const delfile = (idx, type, cidx) => {
  if (type === 'imgList') {
    imgList.value.splice(idx, 1)
  } else {
    const item = resImgList.value[idx]
    const imgIdx = imgList.value.findIndex((ele) => ele.url === item.path[cidx].url)
    if (imgList.value[imgIdx]) {
      imgList.value[imgIdx].isHide = false
    }
    if (item.path.length === 1) {
      resImgList.value.splice(idx, 1)
    } else {
      item.path.splice(cidx, 1)
    }
  }
}

const checkAll = (val) => {
  for (const ele of resImgList.value) {
    ele.isCheck = val
  }
  isIndeterminate.value = false
}

const changeSingle = (val) => {
  const len = resImgList.value.filter((item) => item.isCheck).length
  isCheckAll.value = len === resImgList.value.length
  isIndeterminate.value = len > 0 && len < resImgList.value.length
}

const getListInfo = () => {
  const li = props.uploadList.map((item) => {
    return {
      ...item,
      isLoading: true
    }
  })
  imgList.value = li

  for (const key in imgList.value) {
    const ele = imgList.value[key]
    const param = {
      path: MY_CONSTANTS.$imgurl,
      fileurl: ele.url,
      fieldset: fieldset.value
    }
    if (ele.type === 'document' && ele.aiRecognizeUrl) {
      param.fileurl = ele.aiRecognizeUrl
    }
    aiextractfilemetadata(param).then((res) => {
      if (res.code === 0) {
        let name = ''
        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
        for (const ele in data) {
          const v = data[ele]
          if (v) {
            name += `${v}+`
          }
        }
        // 删除最后一个+号
        name = name.slice(0, -1)
        ele.info.name = name
        ele.tips = name || '未识别到内容'
      }
      changeMatch(ele, ele.info.name)
    })
  }
}

const changeMatch = (ele, name) => {
  // 获取匹配规则
  const idx = checkList.value.findIndex((item) => item.label === name)
  if (idx > -1) {
    const cidx = resImgList.value.findIndex((item) => item.label === name)
    const cp = { url: ele.url, type: ele.type, previewUrl: ele.previewUrl, fileType: ele.fileType, name: ele.name }
    if (cidx === -1) {
      const obj = {
        ...checkList.value[idx],
        path: [cp],
        fieldset: props.uploadInfo.list[0].field,
        id: getRandom(100, 999999),
        isCheck: true
      }
      resImgList.value.push(obj)
    } else {
      resImgList.value[cidx].path.push(cp)
    }
    ele.isHide = true
  }
  ele.isLoading = false
}


const reset = () => {
  imgList.value = []
  resImgList.value = []
}

const confirm = () => {
  const li = resImgList.value.filter((item) => item.isCheck).map(item => {
    return {
      approvingId: item.approvingId,
      value: item.path.map(ele => {
        return {
          response: ele.url
        }
      })
    }
  })
  emit('confirm', {
    approvalId: props.uploadInfo.appId,
    value: li,
    feild: props.uploadInfo.list[0].field
  })
}


const checkList = computed(() => {
  const { data, list } = props.uploadInfo
  const rules = list[0].namerule
  const res = []
  for (const ele of data) {
    for (const key of rules) {
      const { datafield } = key
      let str = ''
      for (const ckey in datafield) {
        const cele = datafield[ckey]
        const title = cele.split('_')[0]
        let value = ele[title]
        if (Array.isArray(value)) {
          value = value.map(item=> item.name || item.realname).join(',')
        } else if (typeof value === 'object') {
          value = value.name || value.realname
        }
        if (value) {
          if (ckey === '0') {
            str += `${value}`
          } else {
            str += `+${value}`
          }
        }
      }
      res.push({
        approvingId: ele.approvingId,
        label: str
      })
    }
  }
  return res
})

const imgShowList = computed(() => {
  return imgList.value.filter(item => !item.isHide)
})

const fieldset = computed(() => {
  const list = props.uploadInfo.list
  const li = []
  if (list && list[0] && list[0].namerule && list[0].namerule[0]) {
    for (const ele of list[0].namerule[0].datafield) {
      const title = ele.split('_')[0]
      const name = props.uploadInfo.appProperty.find(f => f.title === title)?.name
      li.push(name)
    }
  }
  return li
})

defineExpose({
  getListInfo,
  reset
})



</script> 

<template>
  <div class="photo-sorting">
    <div class="photo-sorting-title">
      <div class="title-tips">
        <div class="file-num">
          <i class="iconfont icon-xuanzewenjian"></i>
          总文件数 {{ imgList.length }}
        </div>
        <div class="file-interval">|</div>
        <div class="file-success">
          <i class="iconfont icon-shibiechenggong"></i>
          识别成功
        </div>
        <div class="file-interval">|</div>
        <div class="file-tobe">
          <i class="iconfont icon-daiqueren"></i>
          待确认
        </div>
      </div>
      <div class="title-tips">
        需处理：请确认 {{ imgShowList.length }} 份错误文件
      </div>
    </div> 
    <div class="photo-sorting-tobe">
      <div class="tobe-title">
        <div class="tobe-title-left">
          <img src="./img/toBeSorted.png" alt="">
          待分拣
        </div>
        <div class="tobe-title-right">
          请手动选择匹配条件，文件将自动移到下方已分拣区
        </div>
      </div> 
      <div class="tobe-content">
        <div class="tobe-content-item" v-for="(item, idx) in imgList" :key="item" v-loading="item.isLoading" v-show="!item.isHide">
          <div class="item-img">
            <template v-if="item.type === 'image'">
              <el-image :src="item.previewUrl"></el-image>
            </template>
            <template v-else-if="item.type === 'document'">
              <div class="document-style">
                <el-image fit="cover" :src="getImg(item.fileType)" />
                <span style="margin-top: 5px;" class="document-name">{{ item.name }}</span>
              </div>
            </template>
            <toolModel @open="openfile(item)" @del="delfile(idx, 'imgList')" />
          </div>
          <div class="item-select">
            <div class="item-select-tips">
              <i class="iconfont icon-cuowu"></i>
              <span class="tips">{{ item.tips }}</span>
            </div>
            <div class="item-select-input">
              <el-select @change="changeMatch(item, $event)" placeholder="请选择">
                <el-option v-for="(opt, idx) in checkList" :key="idx" :label="opt.label" :value="opt.label"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="photo-sorting-be">
      <div class="be-title">
        <div class="be-title-left">
          <img src="./img/success.png" alt="">
          已完成分拣
        </div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="isCheckAll" @change="checkAll" label="全选" />
      </div> 
      <div class="be-content" v-if="resImgList.length !== 0">
        <div class="be-content-item" v-for="(val, valIdx) in resImgList" :key="valIdx"> 
          <div class="item-title">
            <el-checkbox @change="changeSingle" v-model="val.isCheck" :label="val.label"></el-checkbox>
            <div>
              {{ val.path.length }}页
            </div>
          </div>
          <div class="item-img">
            <div class="item-img-empty" v-if="val.path.length === 0">
              <template v-if="val.path.length === 0">
                暂无数据
              </template>
            </div>
            <div class="item-img-container" v-else>
              <div v-for="(item, itemIdx) in val.path" :key="itemIdx" class="img-list">
                <template v-if="item.type === 'document'">
                  <div class="document-style">
                    <el-image fit="cover" :src="getImg(item.fileType)" />
                    <span style="margin-top: 5px;" class="document-name">{{ item.name }}</span>
                  </div>
                </template>
                <template v-else-if="item.type === 'image'">
                  <el-image fit="cover" :src="item.previewUrl"></el-image>
                </template>
                <toolModel @open="openfile(item)" @del="delfile(valIdx, 'resImgList', itemIdx)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="photo-sorting-foot">
      <div class="foot-back-btn" @click="emit('back')">
        返回重新上传
      </div>
      <div class="foot-confirm-btn" @click="confirm">
        <el-icon color="#fff" style="margin-right: 5px;"><Check /></el-icon>
        确认提交
      </div>
    </div>
    <el-image-viewer
      v-if="showPreview"
      :url-list="srcList"
      show-progress
      :initial-index="0"
      @close="showPreview = false"
    />
  </div>
</template>

<style scoped lang='scss'>
.document-style {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .el-image {
    width: 42px !important;
    height: 40px !important;
  }

  .document-name {
    color: #2563EB;
    font-weight: 400;
    font-size: 14px;
    width: 100%;
    padding: 0 5px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
  }
}
.photo-sorting {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 30px;
  overflow: auto;
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-tips {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: #F97316;
      .file-num {
        color: #8B7E92;
      }
      .file-success {
        color: #1CAE52;
      }
      .file-tobe {
        color: #F97316;
      }
      .file-interval {
        margin: 0 10px 0 20px;
        color: #8B7E92;
      }
    }
  }
  &-tobe { 
    margin-top: 35px;
    .tobe-title {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-left {
        display: flex;
        align-items: center;
        color: #F97316;
        font-weight: 400;
        font-size: 16px;
        img {
          width: 25px;
          height: 26px;
          margin-right: 5px;
        }
      }
      &-right {
        font-family: uniqueID;
        color: #4E4E4D;
        font-weight: 400;
        font-size: 16px;
      }
    }
    .tobe-content {
      min-height: 304px;
      border-radius: 18px;
      background-color: #FFFCFA;
      border: 2px solid rgba(249, 115, 22, 0.2);
      box-sizing: border-box;
      padding: 16px;
      display: flex;
      flex-wrap: wrap;
      &-item {
        width: 214px;
        height: 272px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        margin-right: 10px;
        margin-bottom: 10px;
        &:nth-of-type(6n) {
          margin-right: 0;
        }
        .item-img {
          height: 191px;
          position: relative;
          .el-image {
            width: 100%;
            height: 100%;
          }
        }
        .item-select {
          height: 81px;
          box-sizing: border-box;
          font-weight: 400;
          font-size: 16px;
          padding: 12px;
          &-tips {
            color: #F97316;
            font-weight: 400;
            font-size: 12px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            i {
              margin-right: 5px;
            }
            .tips {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              flex: 1;
            }
          }
        }
      }
    }
  }
  &-be {
    margin-top: 35px;
    .be-title {
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      &-left {
        display: flex;
        align-items: center;
        color: #1CAE52;
        font-weight: 400;
        font-size: 16px;
        margin-right: 18px;
        img {
          width: 25px;
          height: 26px;
          margin-right: 5px;
        }
      }
    }
    .be-content {
      border-radius: 18px;
      box-sizing: border-box;
      background-color: #FFFFFF;
      border: 2px solid rgba(139, 126, 146, 0.2);
      padding: 16px;
      display: flex;
      flex-wrap: wrap;
      &-item {
        min-height: 131px;
        width: 255px;
        border-radius: 8px;
        border: 2px solid #DCDFE6;
        margin-right: 10px;
        margin-bottom: 10px;
        &:nth-of-type(5n) {
          margin-right: 0;
        }
        .item-title {
          height: 48px;
          padding: 0 12px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #DCDFE6;
        }
        .item-img {
          padding: 14px;
          box-sizing: border-box;
          &-empty {
            background-color: #FAFAFA;
            border: 1px dashed rgba(0, 0, 0, 0.1);
            min-height: 55px;
            color: #B5B1B1;
            font-weight: 400;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          &-container {
            min-height: 55px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .img-list {
              width: 106px;
              height: 130px;
              margin-right: 10px;
              margin-bottom: 10px;
              box-shadow: 0px 0px 4.64px 0px rgba(180, 182, 188, 0.5);
              border-radius: 4px;
              position: relative;
              &:nth-of-type(2n) {
                margin-right: 0;
              }
              .el-image {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
  &-foot {
    width: 100%;
    display: flex;
    margin-top: 30px;
    align-items: center;
    justify-content: flex-end;

    .foot-confirm-btn {
      width: 140px;
      height: 40px;
      border-radius: 4px;
      background: linear-gradient(46.68deg, rgba(37, 170, 246, 1) 0%, rgba(39, 145, 245, 1) 24.94%, rgba(111, 105, 255, 1) 77.88%, rgba(166, 107, 255, 1) 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-weight: 400;
      font-size: 16px;
      cursor: pointer;
      user-select: none;
    }
    .foot-back-btn {
      width: 140px;
      height: 40px;
      border-radius: 4px;
      background: #FFFFFF;
      border: 1px solid #999999;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      color: #676262;
      font-weight: 400;
      font-size: 16px;
      cursor: pointer;
      user-select: none;
      margin-right: 16px;
    }
  }
}
</style>
